import { type ModalProps } from '../types';
import styles from '../Modal@desktop.module.css';

export const getSizeClassName = (size: ModalProps['size'], verticalStackClassName?: string) => {
    switch (size) {
        case 'small':
            return styles.Modal_size_small;

        case 'normal':
            return styles.Modal_size_normal;

        case 'large':
            return styles.Modal_size_large;

        case 'extra-large':
            return [styles.Modal_size_extra_large, verticalStackClassName];

        case 'fullscreen':
            return styles.Modal_size_fullscreen;

        case 'auto':
            return styles.Modal_size_auto;

        case 'overlay-extra-small':
            return styles.Modal_size_overlay_extra_small;

        case 'overlay-small':
            return styles.Modal_size_overlay_small;

        case 'overlay-normal':
            return styles.Modal_size_overlay_normal;

        default:
            return styles.Modal_size_normal;
    }
};
